<ng-template #selectHelpTextModal>
  <p>
    Use Image Selection Mode to choose multiple images to be edited or to be related together.<br>
    <small class="text-muted">Note: you must have more than one thumbnail selected before you can batch edit or relate
      records.</small>
  </p>
  <h4>Single Select</h4>
  <ul>
    <li>Click on a thumbnail to select it. A green checkbox will appear over it.</li>
    <li>Alt+click to select text while in Selection Mode. </li>
  </ul>
  <h4>Multi-select</h4>
  <ul>
    <li>
      Ctrl+click/shift+click on thumbnails to add them to the selected group.
    </li>
    <li>Click down and drag to draw a box around a group of thumbnails to select them.</li>
    <li>Shift+drag to add the box selection to existing group.</li>
    <li>Press the <i>Select All</i> button to choose all loaded items.</li>
  </ul>
  <h4>Deselect</h4>
  <ul>
    <li>
      Ctrl+click on selected thumbnails to remove them from the selected group.
    </li>
    <li>
      Click anywhere in the gray gallery floor area to deselect all.
    </li>
    <li>
      Press the <i>Unselect All</i> button to deselect all items.
    </li>
  </ul>
</ng-template>
<ng-template #relateImageSetsModal>
  <!-- <p>
    <i class="fal fa-lg fa-layer-group"></i>
    <strong> Ready to relate {{ batchEditImages.length }} records.</strong>
  </p>
  <div *ngIf="relatedImageSetsForBatch.length > 0">
    <i class="fal fa-info-circle text-info"></i>
    One or more of the selected images already belong to a set.<br>
    If you would like to add this selection to one of those existing sets, please choose from below: <br>
    <select class="form-control" [(ngModel)]="selectedImageSetUIDDropdown"
      (change)="onExistingSetSelected($event)">
      <option [value]="null">-- Create New Set --</option>
      <option *ngFor="let s of relatedImageSetsForBatch" [value]="s.uid">{{ s.name }}</option>
    </select>
    <br><br><br>
  </div>
  <h5 *ngIf="!selectedImageSetUIDDropdown">Please provide a name for this set:</h5>
  <h5 *ngIf="selectedImageSetUIDDropdown">Using existing set:</h5>
  <input type="text" 
      id="txtRelatedImageSetName" 
      #relatedSetsSearcher 
      [(ngModel)]="relatedSetsSearcherOutput" 
      class="form-control editable focus" 
      [ngbTypeahead]="relatedSetsTypeahead()" 
      name="txtRelatedImageSetName" 
      maxlength="150" 
      [focusFirst]="false" 
      [disabled]="selectedImageSetUIDDropdown"
      placeholder="Type a name for the set" 
      (keydown.Tab)="ignoreTypeaheadSuggestion = true" 
      (focus)="relatedSetTypeFocus$.next($any($event).target.value)" 
      (blur)="ignoreTypeaheadSuggestion = false; this.relatedSetsSearcherOutput = relatedSetsSearcher.value;" 
      (selectItem)="interceptTypeaheadSelection($event)"
      [resultFormatter]="resultFormatter"
      [inputFormatter]="inputFormatter">
  <br><br><br><br><br> -->
  <p>
    <i class="fal fa-lg fa-layer-group"></i>
    <strong> Ready to relate {{ batchEditImages.length }} records.</strong>
  </p>
  
  <!-- Dropdown only for sets that selected images already belong to -->
  <div *ngIf="relatedImageSetsForBatch && relatedImageSetsForBatch.length > 0">
    <i class="fal fa-info-circle text-info"></i>
    One or more of the selected images already belong to a set.<br>
    If you would like to add this selection to one of those existing sets, please choose from below: <br>
    <select class="form-control" 
      [(ngModel)]="selectedImageSetUIDDropdown"
      (change)="onExistingSetSelected($event)">
      <option value="">-- Choose from dropdown or search below --</option>
      <option *ngFor="let s of relatedImageSetsForBatch" [value]="s.uid">{{ s.name }}</option>
    </select>
    <br><br>
  </div>

  <!-- Autocomplete for searching all sets or creating new -->
  <h5 *ngIf="!selectedImageSetUIDDropdown">
    <i class="fal fa-search"></i> Search existing sets or enter a new name:
  </h5>
  <h5 *ngIf="selectedImageSetUIDDropdown">
    <i class="fal fa-check-circle text-success"></i> Adding to existing set:
  </h5>

  <input type="text" 
      id="txtRelatedImageSetName" 
      class="form-control editable focus" 
      [formControl]="relatedSetControl"
      [matAutocomplete]="relatedSetAuto"
      maxlength="150" 
      placeholder="Type to search existing sets or enter new name"
      autocomplete="off">
  
  <mat-autocomplete #relatedSetAuto="matAutocomplete" 
    (optionSelected)="onRelatedSetSelected($event.option.value)">
    <mat-option *ngFor="let set of filteredRelatedSets | async" [value]="set.name">
      {{ set.name }}
    </mat-option>
  </mat-autocomplete>
  
  <!-- Show indication of what will happen -->
  <div class="mt-2" *ngIf="!selectedImageSetUIDDropdown">
    <small class="text-muted" *ngIf="!relatedSetsSearcherOutputUID && relatedSetControl.value">
      <i class="fal fa-plus-circle text-success"></i> Will create new set: "<strong>{{ relatedSetControl.value }}</strong>"
    </small>
    <small class="text-muted" *ngIf="relatedSetsSearcherOutputUID">
      <i class="fal fa-arrow-circle-right text-info"></i> Will add to existing set: "<strong>{{ relatedSetControl.value }}</strong>"
    </small>
  </div>
  <br>

  <!-- Only show these fields when creating a NEW set (not when dropdown is selected or existing set is chosen) -->
  <ng-container *ngIf="!selectedImageSetUIDDropdown && !relatedSetsSearcherOutputUID">
    <!-- Description Field (only for new sets) -->
    <div *ngIf="relatedSetControl.value">
      <h5>Description (optional):</h5>
      <textarea class="form-control" 
        [(ngModel)]="relatedSetDescription" 
        rows="3" 
        maxlength="500"
        placeholder="Enter a description for this new related set">
      </textarea>
      <br>
    </div>

    <!-- Set Type Dropdown (only for new sets) -->
    <div *ngIf="relatedSetControl.value">
      <h5>Set Type:</h5>
      <select class="form-control" [(ngModel)]="relatedSetType">
        <option [value]="0">General</option>
        <option [value]="1">Ledger</option>
      </select>
      <br>
    </div>

    <!-- Ordnance Return Checkbox (only for new sets) -->
    <div class="form-check" *ngIf="relatedSetControl.value">
      <input type="checkbox" 
        class="form-check-input" 
        id="chkOrdnanceReturn" 
        [(ngModel)]="isOrdnanceReturnSet">
      <label class="form-check-label" for="chkOrdnanceReturn">
        This is an Ordnance Return Set
      </label>
      <br><br>
    </div>
  </ng-container>

  <!-- Show a message when adding to existing set -->
  <div *ngIf="selectedImageSetUIDDropdown || relatedSetsSearcherOutputUID" class="alert alert-info">
    <i class="fal fa-info-circle"></i> You are adding images to an existing set. The set's properties can be modified through lookup table.
  </div>
</ng-template>

<ng-template #loadingAnim>
  <div class="loader">
    <div *ngIf="message == LOADING_MESSAGE || loadMoreText == LOADING_MESSAGE" [ngClass]="{'mobile': isHandset}" class="loader-inner ball-grid-pulse" style="background-color: var(--RAgray) !important; border: 1px solid var(--RAblue); border-radius: 8px; width: 60px;">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <h6 *ngIf="mainLibraryFilter.sumOfFiltersApplied() >= 3" class="patience">
        <br><br><br><br><br>
        Multiple filters applied. Please be patient &hellip;
      </h6>
      <!-- <h6 *ngIf="civilianMode" class="patience">
        <br><br><br><br><br>
        Searching for civilians. Please be patient &hellip;
      </h6> -->
    </div>
  </div>
</ng-template>

<ng-template #bindImageSetsModal>
  <p>
    <i class="fal fa-lg fa-book"></i> &nbsp;
    <strong> Ready to bind {{ batchEditImages.length }} records.</strong> <br>
  </p>
  <p *ngIf="!addingToBoundSetMode; else addToBoundSetText">
    <i class="fal fa-info-circle"></i>
    Note that only the <i>first</i> image selected will appear in the gallery and is considered to be the "cover" of
    this <i>bound set</i>. <br>The other images will be displayed within the Bound Set, but will no longer be displayed in the Gallery.
  </p>
  <ng-template #addToBoundSetText>
    <p>
      <i class="icon fal fa-exclamation-triangle text-warning"></i>
      Because you chose an existing bound set in your selection, the other images you selected will be appended to that set.
    </p>
  </ng-template>
  <p style="width: 300px; margin: 0 auto; position: inherit;">
    Using this image as the cover:
    <app-thumbnail [imageData]="batchEditImages[0]" [showStacked]="false" [animate]="true"></app-thumbnail>
  </p>
  <h5>{{ addingToBoundSetMode ? 'Using this set name:' : 'Please provide a name for this set:' }}</h5>
  <input type="text" id="txtBoundImageSetName" #txtBoundImageSetName class="form-control editable focus" name="txtBoundImageSetName"
    [(ngModel)]="tempBoundSetName"
    [disabled]="addingToBoundSetMode" maxlength="150" placeholder="Type set name here">
  <br>
</ng-template>

<!-- Filter/Search sidebar -->
<!-- [style.left.px]="showFilters ? 0 : -(mainLibraryControlsWidth$ | async)" 
[ngStyle]="{'display': isHandset? !showFilters? 'none': '': ''}" 
-->
<div id="mainLibraryControls" #mainLibraryControls [ngClass]="{'mobile': isHandset === true}"  [ngStyle]="{'left': showFilters ? 0 : isHandset ?  -(mainLibraryControlsWidth$ | async)+'px' : '-100vw'}" 
  [ngClass]="{'handsetShowFilters' : showFilters && isHandset }"
  [style.left.px]="showFilters ? 0 : -(mainLibraryControlsWidth$ | async)" >
  <div id="libraryControlsResizeBar" appResize dragTarget="#mainLibraryControls" [widthRange]="[200, 500]" ></div>
  <div [hidden]="!showFilters"><!-- Section shows underneath the main menu bar when the menu scrolls away -->
    <img class="shadowImg" src="../../assets/ra-logo.png" [routerLink]="['/gateway']" alt="Research Arsenal shadow logo" title="Return to library selection">
  </div>
  <div *ngIf="showFilters && !isHandset" class="hideFilters ms-2" matTooltip="Hide filters and search sidebar" (click)="toggleFiltersSection()">
    << HIDE
  </div>

  <div *ngIf="isHandset" class="resultInfoDiv" [ngStyle]="
  {'left': (!showFilters) ? '-100vw' : '',
  'position' : (!showFilters ? 'absolute' : '')
}"  >
    <ng-container *ngTemplateOutlet="mobileResultSetInfo" #mobileResultSetInfoTemplate [ngStyle]="{'padding-top':'2em'}" >
    </ng-container>
  </div>

  <app-library-search [dataObs$]="libSearch$" #libraryMainSearch [accentColor]="'#3384ce'" [ngClass]="{'disabled': message === LOADING_MESSAGE}"
    [placeholderText]="'Search ' + imageTypeFilter.typeOfImage + '...'" [maxResults]="typeaheadLimit" [presetValue]="lastSearchString" [configIcon]="'fa-ellipsis-v'" [imageTypeMode]="this.imageTypeFilter.uid"
    (closeFiltersPaneEmitter)="libSearchExecuted()"
    (selectedOutput)="quickSearchDataResults($event)" (searchOutput)="quickSearchTyping($event)" (errorOutput)="searchError($event)">
  </app-library-search>

  <app-library-filter #mainLibraryFilter 
    [isAdmin]="isAdmin || loggedInUser.isInUserGroup('Librarian')" 
    [enabled]="!this.batchEditMode" 
    [rpp]="rpp" 
    [civilianMode]="civilianMode" 
    [imageTypeFilter]="imageTypeFilter" 
    (applyCivilianResearchFilters)="applyCRfilters($event)" 
    (applyFilters)="applyFilters($event)" 
    (resetEmitter)="clearSearchAndResetCivLibs()" 
    (errorEmitter)="handleErrorLoadingFilterData()">
  </app-library-filter>
  <br>
</div>

<div class="libraryFloor" [ngClass]="{'mobile': isHandset === true, 'posFixed':showFilters === true}" #libraryFloor>
  <div  *ngIf="!isHandset" style="position: sticky; top: 1.5em; z-index: 10;">
    <div class="flowOptionsBar btn-toolbar" role="toolbar" aria-label="Grid layout toolbar">
      <label class="flowOptionsBar-label pe-2">Layout </label>
      <div class="btn-group" role="group" aria-label="grid group">
        <button class="btn btn-light" matTooltip="Small grid mode" [ngClass]="{'active': thumbnailGridMode === 0}"
          (click)="condensedMode()">
          <i class="fas fa-th"></i>
          <!-- <span [hidden]="thumbnailGridMode !== 0"> Sm Grid</span> -->
        </button>
        <button class="btn btn-light" matTooltip="Large grid mode" [ngClass]="{'active': thumbnailGridMode === 1}" (click)="gridLargeMode()">
          <i class="fas fa-th-large"></i>
        </button>
        <button class="btn btn-light" matTooltip="Summary mode" [ngClass]="{'active': thumbnailGridMode === 3}"
          (click)="gridSummaryMode()">
          <i class="fas fa-square"></i>
          <i class="fas fa-align-left"></i>
          <!-- <span [hidden]="thumbnailGridMode !== 1"> Info Grid</span> -->
        </button>
        <button class="btn btn-light" matTooltip="List mode" [ngClass]="{'active': thumbnailGridMode === 2}"
          (click)="listMode()">
          <i class="fad fa-lg fa-th-list"></i>
          <!-- <span [hidden]="thumbnailGridMode !== 2"> List</span> -->
        </button>
      </div>
    </div>
  </div>

  <div class="resultSetInfo" *ngIf="!isHandset else mobileResultSetInfo" [style.padding-left.px]="showFilters ? (mainLibraryControlsWidth$ | async) + 10 : 0">
    <!-- First row: Showing, Display up to, Sort -->
    <div class="d-flex align-items-center">
      <div class="showFilters me-3" *ngIf="!showFilters" [ngStyle]="{'font-weight': isHandset ? 'bolder' : ''}" [hidden]="updateSeqMode" matTooltip="Reveal filters and search sidebar" (click)="toggleFiltersSection()">
        SHOW FILTERS >>
      </div>
      <div class="d-flex align-items-center">
        <span class="me-2">Showing</span>
        <span class="badge badge-pill badge-light me-3" style="cursor: default;">
          {{ showLedgerSetsView ? Math.min(libraryLedgerSets.length, currentPage() * rpp) : libImages.length }} of {{ totalRecords() }}
        </span>
        <span class="me-2">{{!isHandset? "Display up to": "Display"}}</span>
        <select class="badge me-3" [(ngModel)]="rpp" (ngModelChange)="changeRpp()" matTooltip="Records at a time">
          <option class="badge" [ngValue]="25">25</option>
          <option class="badge" [ngValue]="35">35</option>
          <option class="badge" [ngValue]="50">50</option>
          <option class="badge" [ngValue]="100">100</option>
        </select>
        <span class="me-2">Sort</span>
        <select class="badge me-3" style="display: inline; width: 210px;" [(ngModel)]="currentSort" [disabled]="updateSeqMode" (change)="resortCurrentLibrary($event.target.value)">
          <option value="1">Numerically</option>
          <option value="0">Alphabetically</option>
          <option value="2">Featured First, Numerically</option>
          <option *ngIf="(lastSearchString && lastSearchString !== '')" value="3">Relevancy</option>
          <option *ngIf="(relatedSetUIDFilterActiveBool)" value="4">Related Albums</option>
        </select>
        <button class="btn btn-link" id="btnThumbnailScrollToggle" [matTooltip]="'Toggle thumbnail scrolling on hover'"
          [ngClass]="{'active': scrollThumbs}" (click)="scrollThumbs = !scrollThumbs">
          <i [ngClass]="{'fas': scrollThumbs, 'fal me-2': !scrollThumbs}" class="fa-rectangle-portrait"></i>
          <i class="fal fa-arrows-v" *ngIf="scrollThumbs"></i>
          <span class="underlineLink">
            <span class="underlineLink d-none d-lg-inline-block">Thumbnail scroll</span>
            {{ scrollThumbs ? ' enabled' : ' disabled' }}
          </span>
        </button>
      </div>
    </div>
    
    <!-- Second row: Filter badges, search badges, and other content -->
    <div class="d-flex align-items-center flex-wrap">
      <button *ngIf="batchEditMode" id="selectHelpButton" class="btn btn-link me-2"
        (click)="modalSvc.postModal(selectModeModal)">
        Selection Mode Help <i class="fal fa-question-circle"></i>
      </button>
      
      <span class="badge badge-light filterBadge me-2" [hidden]="updateSeqMode" *ngIf="mainLibraryFilter.sumOfFiltersApplied() > 0">
        <i class="fal fa-filter me-1"></i>
        <div class="text-nospill">
          {{ mainLibraryFilter.sumOfFiltersApplied() }} {{ mainLibraryFilter.sumOfFiltersApplied() > 1 ? 'filters' : 'filter' }} applied
        </div>
        <div class="close ms-2" style="cursor: pointer;" 
        [matTooltip]="'Clear ' + (mainLibraryFilter.sumOfFiltersApplied() > 1 ? 'these' : 'this') + ' filter'" 
        (click)="removeFilters()">&times;</div>
      </span>

      <span class="badge badge-light filterBadge me-2" [hidden]="updateSeqMode" *ngIf="((lastSearchString && lastSearchString !== '') || keywordFilterActive) && !relatedSetUIDFilterActiveBool">
        <i class="fal fa-search me-1" style="vertical-align: text-top;"></i>
        <div class="text-nospill">
          {{ keywordFilterActive != '' ? 'Filtering by' : 'Searching by' }}
          <span matTooltip="Specific keyword" class="badge badge-pill badge-dark keyword" *ngIf="keywordFilterActive != ''">
           {{ keywordFilterActive }}
          </span>
          <span *ngIf="keywordFilterActive != '' && lastSearchString" class="ms-1 me-1">&#43;</span>
          <span *ngIf="lastSearchString" matTooltip="Searching by specific text">
            "{{ lastSearchString }}"
          </span>
        </div>
        <div class="close ms-2" style="cursor: pointer;" matTooltip="Cancel this search" (click)="removeKeywordFilter()">&times;</div>
      </span>

      <!-- <span class="badge badge-light filterBadge me-2" *ngIf="relatedSetUIDFilterActiveBool">
        <i class="fal fa-search me-1" style="vertical-align: text-top;"></i>
        <div class="text-nospill">
          {{ relatedSetNameFilterActiveName != '' ? 'Showing related set ' : '' }}
          <span style="font-size: larger;" [matTooltip]="relatedSetNameFilterActiveName"  *ngIf="relatedSetUIDFilterActiveBool">
           {{ relatedSetNameFilterActiveName }}
          </span>
        </div>
        <div class="close ms-2" style="cursor: pointer;" matTooltip="Cancel this search" (click)="removeRelatedSetNameFilter()">&times;</div>
      </span> -->
      <span class="badge badge-light filterBadge me-2" *ngIf="relatedSetUIDFilterActiveBool">
        <i class="fal fa-search me-1" style="vertical-align: text-top;"></i>
        <div class="text-nospill">
          Related Set: {{ relatedSetNameFilterActiveName || 'Loading...' }}
        </div>
        <div class="close ms-2" style="cursor: pointer;" 
          matTooltip="Clear this filter" 
          (click)="removeRelatedSetFilter()">&times;</div>
      </span>
<!-- 
      <span class="filterBadge badge-light ps-1 pe-1 me-2" style="font-weight: 500;" *ngIf="civilianMode">
        (Civilian research mode)
      </span> -->
      <span class="filterBadge badge-light ps-1 pe-1 me-2" style="font-weight: 500;" *ngIf="civilianMode">
        (Civilian research mode: <span style="color: var(--RAblue); font-weight: 700;">{{ civilianTypesSelectedCount }} / {{otherLibCounts.length }}</span> selected)
        <app-slant-button [linkMode]="true" btnColor="blue" [btnIconClass]="(civilianTypesSelectedCount === otherLibCounts.length) ? 'fa-circle' : 'fa-check-double'" tooltip="Toggle all/no civilian research selections" (click)="toggleAllCivilianSelections()">
          {{ (civilianTypesSelectedCount > (otherLibCounts.length / 2)) ? 'Deselect ' : 'Select' }} All
        </app-slant-button>
      </span>
      <span class="filterBadge badge-light ps-1 pe-1 me-2" *ngIf="prePrintedMode">
        (Military forms mode: <span style="color: var(--RAred); font-weight: 700;">{{ prePrintedTypesSelected.length }} / {{prePrintedTypes.length }}</span> selected)
        <app-slant-button [linkMode]="true" btnColor="red" [btnIconClass]="(prePrintedTypesSelected.length === prePrintedTypes.length) ? 'fa-circle' : 'fa-check-double'" tooltip="Toggle all/no pre-printed form selections" (click)="toggleAllPrePrintedSelections()">
          {{ (prePrintedTypesSelected.length > (prePrintedTypes.length / 2)) ? 'Deselect ' : 'Select' }} All
        </app-slant-button>
      </span>
    </div>
    
    <div class="prePrintedBadgeContainer" *ngIf="prePrintedMode">

      <div class="PPContainer" *ngIf="showPrePrintedList">
        <div class="filterBadge prePrintedBadge" (click)="togglePrePrintedType(form)" *ngFor="let form of prePrintedTypes" [ngStyle]="{'font-weight': form.selected ? '500' : '400'}">
          <div class="text" [matTooltip]="form.typeOfImage">
            {{ form.typeOfImage }} 
          </div>
          <i class="fa-lg ps-1 ms-1" [ngClass]="{'fa-check-circle fas': form.selected, 'fa-circle fal': !form.selected}" ></i>
        </div>
      </div>

      <div class="prePrintedToggler-button-holder">
        <!-- [ngClass]="{'mobile':isHandset}" -->
        <h6 class="prePrintedToggler" >
            <i [hidden]="showPrePrintedList" class="fa fa-lg fa-caret-down" (click)="togglePPForms()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;View Military Forms ({{prePrintedTypes?.length}})</label>  
            </i>
            <i [hidden]="!showPrePrintedList" class="fa fa-lg fa-caret-up" (click)="togglePPForms()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;Hide Military Forms ({{prePrintedTypes?.length}})</label>  
            </i>
        </h6>
      </div>

    </div>
  </div>

  <ng-template #mobileResultSetInfo>
    <div class="resultSetInfo mobile" [style.padding-left.px]="0">

      <!-- first 1row start -->
      <div class="row resultInfoMobileRow">

        <div class="col-sm-6" style="width: 45vw;">
          <button *ngIf="batchEditMode" id="selectHelpButton" class="btn btn-link"
            (click)="modalSvc.postModal(selectModeModal)">
            Selection Mode Help <i class="fal fa-question-circle"></i>
          </button>
          <span class="showingText">Showing</span>
          <div>
            <span class="badge badge-pill badge-light me-2" style="cursor: default;">
              {{ libImages.length }} of
            {{ totalRecords() }}
          </span> &nbsp;
          </div>
        </div>

        <div class="col-sm-6" style="width: 45vw;">
          {{"Display up to"}}
          <select class="badge me-2" 
                  [disabled]="batchEditMode" 
                  [(ngModel)]="rpp" 
                  (ngModelChange)="changeRpp()" 
                  matTooltip="Records at a time">
            <option class="badge" [ngValue]="25">25</option>
            <option class="badge" [ngValue]="35">35</option>
            <option class="badge" [ngValue]="50">50</option>
            <option class="badge" [ngValue]="100">100</option>
          </select>
        </div>

      </div>
      <!-- first 1row end -->

      <!-- Second 2row start -->
      <div class="row resultInfoMobileRow">

        <div class="col-sm-5 sortByMobile" [ngClass]="{'col-sm-12': mainLibraryFilter.sumOfFiltersApplied()<1}  ">
            <span style="display: flex; flex-wrap: nowrap; align-items: center;">Sort By</span>
            <select class="badge me-1" style="display: inline;" 
            [ngStyle]="
            {'width': (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0) ? '130px' : '130px',
            'width' : ((mainLibraryFilter.sumOfFiltersApplied()<1) ? 'auto' : '130px')
          }" 
            [(ngModel)]="currentSort" (change)="resortCurrentLibrary($event.target.value)" (click)="dropdownOpened = !dropdownOpened">
              
              <option value="1"><span 
                [ngClass]="{
                  'short-text': !dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0, 
                  'full-text': dropdownOpened || (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()<1)}">
                  Numerically</span></option>

              <option value="0"><span 
                [ngClass]="{
                  'short-text': !dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0, 
                  'full-text': dropdownOpened || (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()<1)}">
                  Alphabetically</span></option>

              <option value="2"><span 
                [ngClass]="{
                  'short-text': !dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0, 
                  'full-text': dropdownOpened || (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()<1)}">
                  Featured First, Numerically</span></option>

              <option *ngIf="(lastSearchString && lastSearchString !== '')" value="3"><span 
                [ngClass]="{
                  'short-text': !dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0, 
                  'full-text': dropdownOpened || (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()<1)}">
                  Relevancy</span></option>

              <option *ngIf="(relatedSetUIDFilterActiveBool)" value="4"><span 
                [ngClass]="{
                  'short-text': !dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()>0, 
                  'full-text': dropdownOpened || (!dropdownOpened && mainLibraryFilter.sumOfFiltersApplied()<1)}">
                  Related Albums</span></option>
            </select>
        </div>
        
        <div class="col-sm-6" [ngStyle]="{'display': mainLibraryFilter.sumOfFiltersApplied()<1 ? 'none' : 'block'}" >
          <span class="badge badge-light filterBadge mobile" [hidden]="updateSeqMode" *ngIf="mainLibraryFilter.sumOfFiltersApplied() > 0">
            <i class="fal fa-filter me-1"></i>
            <div class="text-nospill">
              {{ mainLibraryFilter.sumOfFiltersApplied() }} {{ mainLibraryFilter.sumOfFiltersApplied() > 1 ? 'filters' : 'filter' }} applied
            </div>
            <div class="close ms-2" style="cursor: pointer;" 
            [matTooltip]="'Clear ' + (mainLibraryFilter.sumOfFiltersApplied() > 1 ? 'these' : 'this') + ' filter'" 
            (click)="removeFilters()">&times;
            </div>
          </span>
        </div>

      </div>
      <!-- Second 2row end -->

      <!-- third 3rd start -->
      <div class="row resultInfoMobileRow">

        <span class="ms-4 badge badge-light filterBadge" *ngIf="relatedSetUIDFilterActiveBool">
          <i class="fal fa-search me-1" style="vertical-align: text-top;"></i>
          <div class="close ms-2" style="cursor: pointer;" matTooltip="Cancel this search" (click)="removeRelatedSetNameFilter()">&times;</div>
          <div class="text-nospill">
            {{ relatedSetNameFilterActiveName != '' ? 'Showing related set ' : '' }}
            <span style="font-size: larger;" [matTooltip]="relatedSetNameFilterActiveName"  *ngIf="relatedSetUIDFilterActiveBool">
              <div>
              {{ relatedSetNameFilterActiveName }}
              </div>
            </span>
          </div>
          
        </span>
      
        <span class="ms-4 badge badge-light filterBadge" [hidden]="updateSeqMode" *ngIf="((lastSearchString && lastSearchString !== '') || keywordFilterActive) && !relatedSetUIDFilterActiveBool">
          <i class="fal fa-search me-1" style="vertical-align: text-top;"></i>
          <div class="text-nospill">
            {{ keywordFilterActive != '' ? 'Filtering by' : 'Searching by' }}
            <span matTooltip="Specific keyword" class="badge badge-pill badge-dark keyword" *ngIf="keywordFilterActive != ''">
              {{ keywordFilterActive }}
            </span>
            <span *ngIf="keywordFilterActive != '' && lastSearchString" class="ms-1 me-1">&#43;</span>
            <span *ngIf="lastSearchString" matTooltip="Searching by specific text">
              "{{ lastSearchString }}"
            </span>
          </div>
          <div class="close ms-2" style="cursor: pointer;" matTooltip="Cancel this search" (click)="removeKeywordFilter()">&times;</div>
        </span>

      </div>

      <!-- third 3rd end -->

      <div class="row resultInfoMobileRow">

        <div class="modeDiv">
          <!-- <span class="filterBadge badge-light ps-1 pe-1" style="font-weight: 500;" [ngClass]="{'ms-3': mainLibraryFilter.sumOfFiltersApplied() > 0}" *ngIf="civilianMode">
            (Civilian research mode)
          </span> -->
          
          <div class="mode-container" *ngIf="civilianMode">
            <span class="filterBadge badge-light ps-1 pe-1" style="font-weight: 500;" [ngClass]="{'ms-3': mainLibraryFilter.sumOfFiltersApplied() > 0}">
              Civilian research: <span style="color: var(--RAblue); font-weight: 700;">{{ civilianTypesSelectedCount }}/{{otherLibCounts.length }}</span>
            </span>
            <app-slant-button [linkMode]="true" btnColor="blue" [btnIconClass]="(civilianTypesSelectedCount === otherLibCounts.length) ? 'fa-circle' : 'fa-check-double'" tooltip="Toggle all/no civilian research selections" (click)="toggleAllCivilianSelections()">
              {{ (civilianTypesSelectedCount > (otherLibCounts.length / 2)) ? 'Deselect' : 'Select' }} All
            </app-slant-button>
          </div>

          <div class="mode-container" *ngIf="prePrintedMode">
            <span class="filterBadge badge-light ps-1 pe-1" [ngClass]="{'ms-3': mainLibraryFilter.sumOfFiltersApplied() > 0}">
              Military forms: <span style="color: var(--RAred); font-weight: 700;">{{ prePrintedTypesSelected.length }}/{{prePrintedTypes.length }}</span>
            </span>
            <app-slant-button [linkMode]="true" btnColor="red" [btnIconClass]="(prePrintedTypesSelected.length === prePrintedTypes.length) ? 'fa-circle' : 'fa-check-double'" tooltip="Toggle all/no pre-printed form selections" (click)="toggleAllPrePrintedSelections()">
              {{ (prePrintedTypesSelected.length > (prePrintedTypes.length / 2)) ? 'Deselect' : 'Select' }} All
            </app-slant-button>
          </div>
        </div>

      </div>

      <div class="row resultInfoMobileRow" *ngIf="prePrintedMode" style="flex-wrap: wrap;">
        <div class="PPContainer mobile" *ngIf="showPrePrintedList">
          <div class="filterBadge prePrintedBadge" (click)="togglePrePrintedType(form)" *ngFor="let form of prePrintedTypes" [ngStyle]="{'font-weight': form.selected ? '500' : '400'}">
            <div class="text" [matTooltip]="form.typeOfImage">
              {{ form.typeOfImage }} 
            </div>
            <i class="fa-lg ps-1 ms-1" [ngClass]="{'fa-check-circle fas': form.selected, 'fa-circle fal': !form.selected}" ></i>
          </div>
        </div>

        <div class="prePrintedToggler-button-holder">
          <!-- [ngClass]="{'mobile':isHandset}" -->
          <h6 class=" prePrintedToggler" >
              <i [hidden]="showPrePrintedList" class="fa fa-lg fa-caret-down" (click)="togglePPForms()">
                  <label style="font-family: 'Montserrat', serif !important;">&nbsp;View Military Forms ({{prePrintedTypes?.length}})</label>  
              </i>
              <i [hidden]="!showPrePrintedList" class="fa fa-lg fa-caret-up" (click)="togglePPForms()">
                  <label style="font-family: 'Montserrat', serif !important;">&nbsp;Hide Military Forms ({{prePrintedTypes?.length}})</label>  
              </i>
          </h6>
        </div>

      </div>

      <div class="row resultInfoMobileRow">

        <div class="showFilterContainer col-sm-6" id="showFilterContainer">
          <!-- <div class="col-sm-6 showFilters mobile" *ngIf="!showFilters" 
              [ngStyle]="{'font-weight': 'bolder'}"  
              [hidden]="updateSeqMode" 
              matTooltip="Reveal filters and search sidebar" 
              (click)="toggleFiltersSection()">
            SHOW FILTERS >>
          </div> -->

        
          <app-slant-button *ngIf="!showFilters" id="showFiltersButton" btnColor="red" 
          (click)="toggleFiltersSection()" 
          [btnIconClass]="'fa-regular fa-filter'"
          [fontWeight]="'700'"
          [fontSize]="'1.75rem'"
          [iconWidth]="'35%'">
          Show Filters</app-slant-button>
          

          <app-slant-button *ngIf="showFilters" id="showFiltersButton" btnColor="red" 
          (click)="toggleFiltersSection()" 
          [btnIconClass]="'fa-regular fa-filter'"
          [fontWeight]="'700'"
          [fontSize]="'1.75rem'"
          [iconWidth]="'35%'">
          Hide Filters</app-slant-button>

          
        </div>

      </div>
      
    </div>
  </ng-template>
  <!-- resultset info mobile end -->

  <div *ngIf="showLedgerSetsView && libraryLedgerSets.length > 0;" 
       class="ledger-sets-container"
     [style.padding-left.px]="showFilters ? (mainLibraryControlsWidth$ | async) + 10 : 10">
    <h3>Ledgers</h3>

    <div *ngIf="message && message !== LOADING_MESSAGE && message !== ''" class="alert alert-danger">
      {{ message }}
      <button *ngIf="retry" class="btn btn-link" (click)="loadLedgerSets()">Retry</button>
    </div>

    <div class="thumbnailHolder ledger" 
         [ngClass]="{'flexCol': thumbnailGridMode === 2, 'gridLargeMode': thumbnailGridMode === 1, 'mobile': isHandset === true}">
      <app-thumbnail 
        *ngFor="let ledgerSet of libraryLedgerSets; trackBy: trackByUID"
        class="thumbnail-selectable"
        [ngClass]="{'p-2': !isHandset}"
        [@thumbnailFade]="'in'"
        [thumbnailType]="ThumbnailType.LEDGER_SET"
        [isRelatedImageSetViewMode]="false"
        [relatedImageSetViewData]="ledgerSet"
        [isGalleryMode]="true"
        [expandMode]="thumbnailGridMode"
        [animate]="scrollThumbs"
        [searchTerm]="hasActiveFilters ? (lastSearchString || keywordFilterActive) : ''"
        (recordSelectedEmitter)="handleLedgerSetSelection($event)">
      </app-thumbnail>
    </div>

  </div>
   
  <div *ngIf="message && message.length > 0">
    <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
  </div>

  <ng-template #loadMoreMobile>
    <div *ngIf="loadMoreRSButton; else NoMoreRelatedImageSetRecords">
      <app-slant-button (click)="loadMoreRSImages()" class="showMoreButton" [btnIconClass]="'fas fa-chevron-double-down'" [ngClass]="{'largeGrid': thumbnailGridMode === 1, 'disabled': loadMoreText === LOADING_MESSAGE}">{{ loadMoreText }}…</app-slant-button>
      <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
    </div>
  </ng-template>

  <div class="mainRSContainer" id="mainRSContainer">
    <div class="RSContainer" *ngIf="!showLedgerSetsView && (RISSearchResultsToDisplay?.length > 0 && showRSthumbnails) && !isLoading && !selectionMode" [ngClass]="{'openRSContainer': !RSVcontainer, 'mobile':isHandset}">
      <div *ngIf="!RSVcontainer" @fadeInOut class="RSThumbnail" [ngClass]="{'mobile':isHandset}">
        <app-thumbnail *ngFor="let t of RISSearchResultsToDisplay" 
          class="thumb" 
          [animate]="true" 
          [thumbnailType]="t.setType == 0 ? ThumbnailType.RELATED_SET : ThumbnailType.LEDGER_SET"
          [updateSeqMode]="updateSeqMode" 
          [filteringByRSName]="relatedSetNameFilterActive" 
          [isRelatedImageSetViewMode]="true" 
          [relatedImageSetViewData]="t" 
          (recordSelectedEmitter)="handleRSSelectedThumbnail($event)">
        </app-thumbnail>

        <div *ngIf="!isHandset else loadMoreMobile" style="display:flex; justify-content: center;">
          <div *ngIf="loadMoreRSButton; else NoMoreRelatedImageSetRecords" 
            (click)="loadMoreRSImages()" class="showMoreButton" [ngClass]="{'largeGrid': thumbnailGridMode === 1, 'disabled': loadMoreText === LOADING_MESSAGE}">
            {{ loadMoreText }}…
            <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
          </div>
        </div>
      </div>

      <div class="button-holder" #RSButtonID [ngClass]="{'mobile':isHandset, 'viewHideOpen':!RSVcontainer}">
        <h6 class="toggle-button" [ngClass]="{'mobile':isHandset}">
            <i [hidden]="RSVcontainer" class="fa fa-lg fa-caret-up" (click)="toggleRSV()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;Hide Related Albums ({{RISSearchResults?.length}})</label>  
            </i>
            <i [hidden]="!RSVcontainer" class="fa fa-lg fa-caret-down" (click)="toggleRSV()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;View Related Albums ({{RISSearchResults?.length}})</label>  
            </i>
        </h6>
        <!--
         <h6 *ngIf="loadMoreRSButton"class="load-more" (click)="loadMoreRS()">Show more.</h6> OC
        <h6 *ngIf="!loadMoreRSButton"class="load-more" style="color: gray; cursor: default;">No more records.</h6> OC
          -->
      </div>
    </div>
  </div>

  <ng-template #NoMoreRelatedImageSetRecords>
    <div *ngIf="message == '' && RISSearchResults?.length > 10"
      matTooltip="If you want to see more records, try changing your filter parameters or press Reset Filters (in the lower left)." [matTooltipShowDelay]="200"
      class="text-muted showMoreButton noMore" [ngClass]="{'largeGrid': thumbnailGridMode === 1}">No more related albums.</div>
  </ng-template>


  <div class="selection-container" style="display: flex; flex-flow: column;">
    <div *ngIf="civilianMode">

      <div *ngIf="showCivResearchList">
        <div class="imageTypeDivider" [style.padding-left.px]="showFilters ? (mainLibraryControlsWidth$ | async) + 10 : 10">
          <app-lib-select-button *ngFor="let type of otherLibCounts" [config]="libSelectConfigLookup(type.val)" [displayName]="type.txt" [smallMode]="true" [selected]="type.selected" (clickedEmitter)="type.selected = !type.selected; filterCivs()" [browseText]="getTotalGroupCount(type.val) ? getTotalGroupCount(type.val) + ' Civilian records' : ''"></app-lib-select-button>
          <!-- <label [ngClass]="{'grown': !showFilters}" (click)="type.selected = !type.selected" [attr.aria-expanded]="!type.selected" [attr.aria-controls]="'imgTypeCollapse_' + type.val" [matTooltip]="type.selected ? 'Collapse this type' : 'Expand this type'" [matTooltipPosition]="'right'">
            {{ type.txt }} ({{ (libImages | imageTypeGroup : type.val).length }}/{{ getTotalGroupCount(type.val) }})
            <i class="fas fa-lg" [ngClass]="{'fa-caret-down': type.selected, 'fa-caret-right': !type.selected}"></i>
          </label> -->
        </div>
      </div>

      <div class="civResearch-button-holder">
        <!-- [ngClass]="{'mobile':isHandset}" -->
        <h6 class=" civResearchToggler" >
            <i [hidden]="showCivResearchList" class="fa fa-lg fa-caret-down" (click)="toggleCivRes()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;View Civilian Research Record Types ({{otherLibCounts?.length}})</label>  
            </i>
            <i [hidden]="!showCivResearchList" class="fa fa-lg fa-caret-up" (click)="toggleCivRes()">
                <label style="font-family: 'Montserrat', serif !important;">&nbsp;View Civilian Research Record Types ({{otherLibCounts?.length}})</label>  
            </i>
        </h6>
      </div>

    </div>

    <p class="messageContainer" [style.padding-left.px]="(mainLibraryControlsWidth$ | async) - 100" *ngIf="(message !== '' && message !== LOADING_MESSAGE) && !isHandset else messageContainerMobileTemplate"
      [ngStyle]="{'color': messageColor}">
      <span *ngIf="retry">
        <i class="fal fa-times-circle"></i>
      </span>
      <span *ngIf="(!libImages.length && !retry) || reset">
        <i class="fal fa-minus-circle"></i>
      </span>
      {{ message }}
      <span *ngIf="retry"><button class="btn btn-lg btn-link" (click)="reloadData()"> Retry?</button></span>
      <span *ngIf="reset"><button class="btn btn-lg btn-link ps-0" (click)="mainLibraryFilter.resetFilters(true)">Reset Filters.</button></span>
      <br>
    </p>

    <ng-template #messageContainerMobileTemplate>
      <p class="messageContainer mobile" *ngIf="(message !== '' && message !== LOADING_MESSAGE) && isHandset"
      [ngStyle]="{'color': messageColor}">
      <span *ngIf="retry">
        <i class="fal fa-times-circle"></i>
      </span>
      <span *ngIf="(!libImages.length && !retry) || reset">
        <i class="fal fa-minus-circle"></i>
      </span>
      {{ message }}
      <span *ngIf="retry"><button class="btn btn-lg btn-link" (click)="reloadData()"> Retry?</button></span>
      <span *ngIf="reset"><button class="btn btn-lg btn-link ps-0" (click)="mainLibraryFilter.resetFilters(true)">Reset Filters.</button></span>
      <br>
    </p>
    </ng-template>


    <div class="thumbnailHolder" 
        *ngIf="!showLedgerSetsView"
        [ngClass]="{'flexCol': thumbnailGridMode === 2, 'gridLargeMode': thumbnailGridMode === 1, 'mobile': isHandset === true}" 
        [style.padding-left.px]=" isHandset? 0 : showFilters ? (mainLibraryControlsWidth$ | async) + 10 : 10"
        appLassoSelect
        [enabled]="batchEditMode"
        selectableClass="thumbnail-selectable"
        (lassoSelect)="onLassoSelection($event)">

      <app-thumbnail 
        *ngFor="let img of libImages; let idx = index"
        class="thumbnail-selectable"
        [attr.data-image-uid]="img.uid"
        [ngClass]="{
          'selected': isImageSelected(img),
          'focus': img?.uid === lastViewedRecord?.uid, 
          'me-2': thumbnailGridMode === 2,
          'p-2': !isHandset}"
        [@thumbnailFade]="'in'"
        [thumbnailType]="getThumbnailType(img)"
        [id]="'thumbnail' + img.uid" 
        [expandMode]="thumbnailGridMode" 
        [animate]="scrollThumbs" 
        [isGalleryMode]="true"
        [batchEditMode]="batchEditMode" 
        [rsSequenceNumber]="idx+1" 
        [updateSeqMode]="updateSeqMode"
        [filteringByRSName]="relatedSetNameFilterActive" 
        [searchTerm]="searchTerm"
        [imageData]="img"
        (click)="handleThumbnailClick(img, $event)"
        (updatedSeqNumber)="updateSeqNo($event)" 
        (rsSeqNoUpdateActive)="handleMultipleRsUpdate($event)" 
        (recordSelectedEmitter)="handleSelectRecord(img)" 
        (reloadEmitter)="mainLibraryFilter.clearAllFilterDisplays(); reloadData(imageTypeFilter);">
      </app-thumbnail>
    </div>
    
      <div *ngIf="!isHandset else loadMoreMobileLib">
        <div *ngIf="message.toString() == '' && pagesAvailable() > currentPage(); else NoMore" 
          (click)="loadNextPage()" class="showMoreButton"  [ngClass]="{'largeGrid': thumbnailGridMode === 1, 'disabled': loadMoreText === LOADING_MESSAGE}">
          {{ loadMoreText }}…
          <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
        </div>
      </div>
      
      <ng-template #loadMoreMobileLib>
        <div class="loadMoreMobileLibDiv" *ngIf="message.toString() == '' && pagesAvailable() > currentPage(); else NoMore">
          <app-slant-button (click)="loadNextPage()" btnColor="red" class="showMoreButton" [btnIconClass]="'fas fa-chevron-double-down'"  [ngClass]="{'largeGrid': thumbnailGridMode === 1, 'disabled': loadMoreText === LOADING_MESSAGE}">{{ loadMoreText }}…</app-slant-button>
          <ng-container *ngTemplateOutlet="loadingAnim"></ng-container>
        </div>
      </ng-template>

    <ng-template #NoMore>
      <div *ngIf="message == '' && !filteredOtherLibCounts.length"
        matTooltip="If you want to see more records, try changing your filter parameters or press Reset Filters (in the lower left)." [matTooltipShowDelay]="200"
        class="text-muted showMoreButton noMore" [ngClass]="{'largeGrid': thumbnailGridMode === 1}">No more records.</div>
        <ng-container *ngTemplateOutlet="otherLibResults"></ng-container>
    </ng-template>
  
    <ng-template #otherLibResults>
      <div *ngIf="!civilianMode && filteredOtherLibCounts.length && message != LOADING_MESSAGE" class="text-info showMoreButton noMore">
        <br>
        We found more results for your search in these other libraries:<br>
        <div class="otherLibCounts">
          <app-lib-select-button *ngFor="let type of filteredOtherLibCounts" [config]="libSelectConfigLookup(type.val)" [displayName]="type.txt" [smallMode]="true" [browseText]="type.count > 1 ? type.count + ' matches found' : '1 match found'" (clickedEmitter)="changeLibrary(type.val)"></app-lib-select-button>
        </div>
      </div>
    </ng-template>
  
  </div>

  <br>
  <div *ngIf="batchEditMode">
    <app-slant-button 
      id="selectAllButton" 
      btnColor="blue" 
      (click)="batchEditSelectAll()" 
      [btnIconClass]="batchEditImages.length > 0 ? 'fa-square' : 'fa-check-double'">
      {{batchEditImages.length > 0 ? 'Deselect All' : 'Select All'}}
    </app-slant-button> 

    <app-slant-button id="relateImagesButton" [disabled]="batchEditImages.length <= 1" btnColor="blue" btnIconClass="fa-layer-group" (click)="startRelatingImages()">Relate ({{batchEditImages.length}}) Records</app-slant-button>

    <app-slant-button id="bindImagesButton" btnColor="blue" [disabled]="batchEditImages.length <= 1" (click)="startBindingImages()" btnIconClass="fa-book">Bind ({{batchEditImages.length}}) Records</app-slant-button>

    <app-slant-button *ngIf="isAdmin" id="batchEditButton" [disabled]="batchEditImages.length <= 1 || !allowBatchEdit" btnColor="blue" (click)="openBatchEditBox()" btnIconClass="fa-copy">Batch Edit ({{batchEditImages.length}})</app-slant-button>
  </div>

  <!-- update seq button -->
  <app-slant-button *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && relatedSetUIDFilterActiveBool && !updateSeqMode && !isHandset" id="updateSequenceButton" [disabled]="batchEditMode" [btnColor]="'blue'" (click)="turnOnUpdateSequenceMode()" [tooltip]="'Click to update the sequence'" [btnIconClass]="'fa-pencil'">Update Sequence</app-slant-button>

  <!-- cancel update seq button -->
  <app-slant-button *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && relatedSetUIDFilterActiveBool && updateSeqMode" id="updateSequenceButton" [btnColor]="'gray'" (click)="turnOffUpdateSequenceMode('1')" [tooltip]="'Click to cancel'" [btnIconClass]="'fa-times-circle'">Cancel</app-slant-button>

  <!-- save updated seq button -->
  <app-slant-button *ngIf="updateSeqMode" id="saveUpdatedSeq" [disabled]="!currentSeqNumbersModified" [btnColor]="updateSeqMode ? 'blue' : 'gray'" (click)="saveRSSeq()" [tooltip]="'Save the updated sequence'" [btnIconClass]="updateSeqMode ? 'far fa-save' : 'fa-images'">{{updateSeqMode ? 'Save Sequence' : 'Cancel' }}</app-slant-button>

  <app-slant-button 
    *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && !updateSeqMode && !isHandset" 
    id="mainSelectButton" 
    [btnColor]="batchEditMode ? 'gray' : 'blue'" 
    (click)="toggleBatchEditMode()" 
    [tooltip]="'Toggle selection mode'" 
    [btnIconClass]="batchEditMode ? 'fa-times-circle' : 'fa-images'">{{batchEditMode ? 'Cancel' : 'Select Images'}}
  </app-slant-button>

  <app-slant-button *ngIf="(isAdmin || loggedInUser.isInUserGroup('Librarian')) && !updateSeqMode  && !isHandset" [disabled]="batchEditMode" id="mainUploadButton" btnColor="blue" (click)="showUploader = !showUploader" [btnIconClass]="'fa-upload'">Upload Images</app-slant-button>

  <app-batch-uploader *ngIf="isAdmin || loggedInUser.isInUserGroup('Librarian')" [showCard]="showUploader" [maxFileSize]="maxFileSize"
    (refreshTrigger)="reloadData(libImages[0].typeOfImage, true)" (cardClosed)="showUploader = false">
  </app-batch-uploader>
  <!--<app-batch-edit-form *ngIf="showBatchEditBox && isAdmin" [showCard]="showBatchEditBox" [batchEditArray]="batchEditImages"
    (cancelTrigger)="cancelBatchEdit()" (reloadTrigger)="batchEditReload()"></app-batch-edit-form>-->
</div>

<div *ngIf="showBatchEditBox" class="card batchEditForm dragBox" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.dragBox'" [ngClass]="{'activate': showBatchEditBox}">
  <div class="fixedPosition">
    <div class="close" (click)="closeBatchEditBox()" matTooltip="Close" style="position: absolute; right: 0.5em; top: 0.5em;"> &times; </div>
    <h4 class="dragHandle" style="text-align: center; padding: 0.5em; border-bottom: 1px solid;"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i>Batch Edit</h4>
  </div>
  <app-batch-edit-pane [imageType]="imageTypeFilter" [imageModels]="batchEditImages" (closeEmitter)="closeBatchEditBox()" (processCompleteEmitter)="batchEditConfirmed($event)" style="margin-top: 3em;"></app-batch-edit-pane>
</div>
